import React, { useState, useEffect } from "react";
import { auth, database } from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get, set, remove, push, update } from "firebase/database";

const PRMAdmin = () => {
  const [user, setUser] = useState(null);
  const [posts, setPosts] = useState({});
  const [images, setImages] = useState({});
  const [newPost, setNewPost] = useState({ bookmark: "", date: "", image: "", link: "", title: "" });
  const [newImage, setNewImage] = useState("");
  const allowedEmails = [
    "prestigeflight2022@gmail.com",
    "enbybase@gmail.com",
    "youth.priderevolution@gmail.com"
  ];

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user && allowedEmails.includes(user.email)) {
        setUser(user);
        fetchPosts();
        fetchImages();
      } else {
        setUser(null);
      }
    });
  }, []);

  const fetchPosts = async () => {
    const postsRef = ref(database, "partnerships/prmposts");
    const snapshot = await get(postsRef);
    if (snapshot.exists()) {
      setPosts(snapshot.val());
    }
  };

  const fetchImages = async () => {
    const imagesRef = ref(database, "partnerships/prmposts/whoweareimg");
    const snapshot = await get(imagesRef);
    if (snapshot.exists()) {
      setImages(snapshot.val());
    }
  };

  const addPost = async () => {
    if (!newPost.title.trim()) return;
    const postRef = push(ref(database, "partnerships/prmposts"));
    await set(postRef, newPost);
    setNewPost({ bookmark: "", date: "", image: "", link: "", title: "" });
    fetchPosts();
  };

  const addImage = async () => {
    if (newImage.trim() === "") return;
    const imageRef = push(ref(database, "partnerships/prmposts/whoweareimg"));
    await set(imageRef, newImage);
    setNewImage("");
    fetchImages();
  };

  const updatePost = async (postId, field, value) => {
    await update(ref(database, `partnerships/prmposts/${postId}`), { [field]: value });
    fetchPosts();
  };

  const deletePost = async (postId) => {
    await remove(ref(database, `partnerships/prmposts/${postId}`));
    fetchPosts();
  };

  const deleteImage = async (imageId) => {
    await remove(ref(database, `partnerships/prmposts/whoweareimg/${imageId}`));
    fetchImages();
  };

  if (!user) return <p>Access Denied</p>;

  return (
    <div className="prm-bg">
    <div className="prmad-container">
      <h1 className="prmad-title">PRMAdmin Console</h1>
      
      <h2 className="prmad-section-title">Manage Posts</h2>
      <input className="prmad-input" type="text" placeholder="Title" value={newPost.title} onChange={(e) => setNewPost({...newPost, title: e.target.value})} />
      <input className="prmad-input" type="text" placeholder="Bookmark" value={newPost.bookmark} onChange={(e) => setNewPost({...newPost, bookmark: e.target.value})} />
      <input className="prmad-input" type="text" placeholder="Date" value={newPost.date} onChange={(e) => setNewPost({...newPost, date: e.target.value})} />
      <input className="prmad-input" type="text" placeholder="Image URL" value={newPost.image} onChange={(e) => setNewPost({...newPost, image: e.target.value})} />
      <input className="prmad-input" type="text" placeholder="Link" value={newPost.link} onChange={(e) => setNewPost({...newPost, link: e.target.value})} />
      <button className="prmad-button" onClick={addPost}>Add Post</button>
      <ul className="prmad-list">
  {Object.keys(posts)
    .filter((id) => id !== "whoweareimg") // Exclude whoweareimg
    .map((id) => (
      <li className="prmad-list-item" key={id}>
        <strong>{id}</strong>
        {Object.keys(posts[id]).map((field) => (
          <input
            key={field}
            className="prmad-input"
            type="text"
            value={posts[id][field]}
            onChange={(e) => updatePost(id, field, e.target.value)}
            placeholder={field}
          />
        ))}
        <button className="prmad-button" onClick={() => deletePost(id)}>Delete</button>
      </li>
    ))}
</ul>

      
      <h2 className="prmad-section-title">Manage Images</h2>
      <input className="prmad-input" type="text" value={newImage} onChange={(e) => setNewImage(e.target.value)} placeholder="Image URL" />
      <button className="prmad-button" onClick={addImage}>Add Image</button>
      <ul className="prmad-list">
        {Object.keys(images).map((id) => (
          <li className="prmad-list-item" key={id}>
            <strong>{id}</strong>
            <input
              className="prmad-input"
              type="text"
              value={images[id]}
              onChange={(e) => update(ref(database, `partnerships/prmposts/whoweareimg/${id}`), e.target.value)}
            />
            <img className="prmad-image" src={images[id]} alt="Uploaded" width={100} />
            <button className="prmad-button" onClick={() => deleteImage(id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div></div>
  );
};

export default PRMAdmin;
